export var escapeRegExp = function (string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string
export var storeProductVariantAppendix = function (customVariants) {
    return new RegExp("(\\s(Color|Size".concat((customVariants === null || customVariants === void 0 ? void 0 : customVariants.length)
        ? '|' + customVariants.map(escapeRegExp).join('|')
        : '', "):\\s.+;)+?\\s*$"));
};
//# sourceMappingURL=regex.js.map